import { createSlice } from '@reduxjs/toolkit';
import { setToStore } from '../utils/fn';
import constants from '../utils/constants.json';

export const recentlyViewedSlice = createSlice({
	name: 'recentlyViewed',
	initialState: {
		data: null,
	},
	reducers: {
		setRecentlyViewed: function (state, action) {
			state.data = action.payload;
		},

		addRecentlyViewed: function (state, action) {
			if (!state.data || state.data.length === 0) {
				state.data = [action.payload];
			} else {
				state.data.forEach((item, index) => {
					if (item.item_code === action.payload.item_code) {
						state.data.splice(index, 1);
					}
				});
				if (state.data.length >= 20) state.data.pop();
				state.data.unshift(action.payload);
			}
			setToStore(constants.RECENTLY_VIEWED, state.data);
		},
	},
});

export const { setRecentlyViewed, addRecentlyViewed } = recentlyViewedSlice.actions;
export default recentlyViewedSlice.reducer;
